import { useEffect, useState } from "react";
import api from "@/lib/api";

// Cachea /api/settings a nivel de módulo: una sola request para toda la app.
// REGLA PEDIDA POR CAMILA: eventos, mezclas de estilos y las categorías Íntima y
// Carteras van OCULTAS POR DEFECTO (en el código, no solo en la DB). Se reactivan
// desde Panel → Ajustes → Secciones visibles cuando quiera usarlas.
let _cache = null;
let _promise = null;

export const DEFAULT_CATEGORIES = ["denim", "accesorios"];

const DEFAULTS = { events_enabled: false, style_mix_enabled: false, releases_enabled: true, historic_enabled: false, creator_enabled: false, enabled_categories: DEFAULT_CATEGORIES, sales_stage: "exhibicion", counter_display: "exact" };

const CATEGORIES_FULL = [
  { key: "denim", label: "Denim Intervenido" },
  { key: "intima", label: "Íntima / Corsetería" },
  { key: "accesorios", label: "Accesorios" },
  { key: "carteras", label: "Carteras / Bolsos" },
];

export default function useSettings() {
  const [s, setS] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    if (!_promise) {
      _promise = api.get("/settings")
        .then((r) => { _cache = { ...DEFAULTS, ...r.data }; return _cache; })
        .catch(() => ({ ...DEFAULTS }));
    }
    _promise.then((d) => setS(d)).catch(() => {});
  }, []);
  return { ...DEFAULTS, ...(s || {}) };
}

export function visibleCategories(settings) {
  const enabled = settings?.enabled_categories;
  if (!Array.isArray(enabled) || enabled.length === 0) {
    // sin lista explícita (DB vieja sin la clave) => aplicamos el default de la marca
    return CATEGORIES_FULL.filter((c) => DEFAULT_CATEGORIES.includes(c.key));
  }
  return CATEGORIES_FULL.filter((c) => enabled.includes(c.key));
}
